import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import marked from 'marked'
import { ExplorerHeader } from '../components'
import { Segment, Table, Label } from 'semantic-ui-react'
import Enumerable from 'linq'

const mapStateToProps = state => {
  return {
    apis: state.apis,
    operations: state.operations
  }
}
class Welcome extends Component {
  render () {
    const apisArray = this.props.apis.get('byOrder').map(name => ({
      apiname: name,
      spec: this.props.apis.get('byName').get(name)
    })).toArray()
    return (
      <div>
        {apisArray.map(this.renderSingleAPIContent)}
      </div>
    )
  }

  renderStatusCodes () {
    return (
      <Table.Body className='operation-status'>
        <Table.Row>
          <Table.Cell className='one wide'><Label size='tiny'>200</Label></Table.Cell>
          <Table.Cell className='fifteen wide'>Successful operation.</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell className='one wide'><Label size='tiny'>400</Label></Table.Cell>
          <Table.Cell className='fifteen wide'>Required parameters not supplied.</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell className='one wide'><Label size='tiny'>401</Label></Table.Cell>
          <Table.Cell className='fifteen wide'>Invalid API key, access to catalog denied.</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell className='one wide'><Label size='tiny'>404</Label></Table.Cell>
          <Table.Cell className='fifteen wide'>Resource requested is not found, preview not available, download URL not available for part number.</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell className='one wide'><Label size='tiny'>415</Label></Table.Cell>
          <Table.Cell className='fifteen wide'>Part number not available in CAD format.</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell className='one wide'><Label size='tiny'>500</Label></Table.Cell>
          <Table.Cell className='fifteen wide'>Unable to access the server.</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell className='one wide'><Label size='tiny'>503</Label></Table.Cell>
          <Table.Cell className='fifteen wide'>Request limit reached.</Table.Cell>
        </Table.Row>
      </Table.Body>
    )
  }

  renderSingleAPIContent = (apiInfo) => {
    if (!apiInfo) return
    const apiConfiguration = APIExplorer.apiConfigurations.find(c => c.friendlyName === apiInfo.apiname)
    return (
      <div key={apiInfo.apiname}>
        <Segment>
          {this.renderTitle(apiInfo)}
          <div>
            <p>
              Welcome to the Endeavor 3DX Media API documentation. The API allows direct access to your hosted 3D catalogs
              on the Endeavor 3DX Media infrastructure, in which you can use to implement your own desired functionality and
              interface in your environment.
            </p>
            <p>
              We recommend you also review the ‘Hosted Catalog Services’ APIs, which are complete generic
              applications for a number of common catalog access functionalities which can be used in an iframe
              within your environment. If a generic implementation of typical catalog access, including such things as
              browsing, viewing and downloading is desired, then please consider using these APIs in your
              environment as it will significantly reduce your development, implementation and maintenance
              overhead.
            </p>
            <p>
              All APIs will have a ‘Details’ section which outlines the API usage and parameter details, an asterisk (*) beside any parameter 
              indicates that parameter is required. There is also a ‘Try It’ section which allows you to actual try the API in real time. 
              Once you execute the API, you will be presented with the complete API URL, with all specified parameters, 
              that you can use as a reference in your own implementation as needed.
            </p>
          </div>
          <br />
          <Segment>
            <h4>Requirements</h4>
            <p>The following requirements are necessary when using the Endeavor 3DX media API:</p>
            <ul>
              <li>Requests require HTTPS.</li>
              <li>Requests can be POST or GET, except those passing the "data" key - these must be POST.</li>
              <li>Requests respond with JSON (data or error) except Downloads and Previews.</li>
              <li>
                All requests, with the exception of the ‘Hosted Catalog Services’ APIs, must contain your API key. 
                An APIKey is uniquely assigned to your catalog and must be used to allow dedicated access to your catalog. 
                If you do not have an API key, please contact Endeavor Business Media via 3dxsupport@endeavorb2b.com.
                Also note, that to use the 3DX 'Reporting and Statistics' API's, your assigned API key must
                have the analytic access option turned on, else you will be denied. By default, all API keys have
                the analytic access option turned off, if you need to use the analytic API's in your implementation and your API
                key does not have analytic access, please contact Endeavor Business Media via 3dxsupport@endeavorb2b.com to request analytic API access.
              </li>
              <li>If your servers will be making requests to our API, please make sure to override your Request Headers to include the following:
                <ul>
                  <li>"X-Forwarded-For" or "CLIENT_IP": This should be the Browser's IP Address not your servers IP Address.</li>
                  <li>Referrer: This should be the URL (or name) of your application making the request.</li>
                </ul>
              </li>
            </ul>
          </Segment>
          <Segment>
            <h4>Response Status Codes</h4>
            <Table striped>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell content='Response' />
                  <Table.HeaderCell content='Description' />
                </Table.Row>
              </Table.Header>
              {this.renderStatusCodes()}
            </Table>
          </Segment>
        </Segment>
        {/* {apiConfiguration.welcome.displaySummary && this.renderDescription(apiInfo)} */}
        {/* {apiConfiguration.welcome.listOperations && this.renderSummary(apiInfo)} */}
      </div>
    )
  }

  renderTitle = (apiInfo) => {
    const { title, version } = apiInfo.spec.info
    return <ExplorerHeader api={{ apiName: title, apiVersion: version, productVersion: version }} />
  }

  renderDescription = (apiInfo) => {
    return <p dangerouslySetInnerHTML={this.getHtmlDescription(apiInfo.spec.info.description)} />
  }

  renderSummary = (apiInfo) => {
    const apiOperations = this.props.operations.filter(o => o.get('apiname') === apiInfo.apiname).map(o => o.get('spec')).toArray()
    let pathsByTags = Enumerable.from(apiOperations).groupBy(o => o.tags ? o.tags[0] : '')

    return pathsByTags.select(g => {
      let key = g.key()
      const api = this.props.apis.get('byName').get(apiInfo.apiname)
      const tag = api.hasOwnProperty('tags') ? api.tags.find(t => t.name === key) : undefined
      const tagDescription = tag ? tag.description || tag.key : key
      return <Segment key={key}>
        {/* <h4>{tagDescription}</h4> */}
        <Segment>
          <h4>{key}</h4>
          <Table compact striped columns='two'>
            <Table.Header>
              <Table.Row>
                {/* <Table.HeaderCell content='Operation' /> */}
                <Table.HeaderCell content='HTTP Request' />
                <Table.HeaderCell content='Description' />
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {g.select(this.renderSummaryRow).toArray()}
            </Table.Body>
          </Table>
          {/* <br /> */}
        </Segment>
      </Segment>
    }).toArray()
  }

  renderSummaryRow = (operation) => {
    const url = APIExplorer.LinkGenerator.toOperation(operation)
    return (
      <Table.Row key={operation.httpMethod + operation.url}>
        {/* <Table.Cell>
          <Link to={url} >{operation.httpMethod}</Link>
        </Table.Cell> */}
        <Table.Cell width={2}><Link to={url} ><code>{`${operation.url}`}</code></Link></Table.Cell>
        <Table.Cell content={operation.summary} />
      </Table.Row>
    )
  }

  getHtmlDescription = (description) => {
    return { __html: marked(description || '') }
  }
}

export default connect(mapStateToProps)(Welcome)



// WEBPACK FOOTER //
// ./src/containers/Welcome.js